<template>
  <div class="form-container">
    <div v-if="storage.state === 4 && storage.info['code']" class="header">
      <div class="title">{{ storage.info['title'] || '' }}</div>
      <div class="desc">{{ storage.info['description'] || '' }}</div>
    </div>
    <From
      v-show="storage.state === 4"
      v-model:data="storage.data"
      :form="storage.form"
      :loading="storage.loading"
      @submit="onSubmit"
    />
    <Tips
      :show="[1, 2, 3, 5].includes(storage.state)"
      :type="storage.tips['type']"
      :text="storage.tips['text']"
    />
  </div>
</template>

<script setup>
import From from '@/components/Form'
import Tips from '@/components/Tips'
import { reactive } from 'vue'
import { Toast } from 'vant'
import { useRoute } from 'vue-router'
import { uploadImage, getStorage, setStorage } from '@/utils'
import { getFormDetail, submitForm } from '@/api'

window.document.title = '第一赛道表单'
const route = useRoute()
const storage = reactive({
  code: '',
  state: 0, // 0-默认 1-已提交 2-提交失败 3-未开始 4-进行中 5-已结束
  loading: false,
  data: {},
  form: [],
  info: {},
  submitList: [],
  tips: {
    type: 'default',
    text: ''
  }
})

// 提交表单
const onSubmit = async () => {
  try {
    let isError = false
    storage.loading = true
    const data = []
    for(const item of storage.form) {
      const { prop, label, desc, type } = item
      const value = storage.data[prop]
      if (type === 7 && value) { // 如果类型是图片的
        const res = await uploadImage(value[0].file, 'image')
        if (res.code === 200) {
          data.push({
            prop,
            label,
            desc,
            content: res.data
          })
        } else {
          isError = true
          break
        }
      } else {
        data.push({
          prop,
          label,
          desc,
          content: type === 10 ? value.join(',') : value || ''
        })
      }
    }
    console.log('data: ', data)
    if (isError) {
      Toast.fail('提交失败')
    } else {
      const res = await submitForm({
        formId: storage.info['formId'],
        infoField: data
      })
      if (res.code === 200) {
        setTips({ state: 1, text: '已提交' })
        setStorage('submit-list', [...storage.submitList, storage.code])
      }
    }
    storage.loading = false
  } catch (e) {
    storage.loading = false
  }
}
// 设置 tips
const setTips = ({ state = 1, type = 'default', text } = {}) => {
  storage.state = state
  switch (state) {
    case 1: {
      type = 'success'
      break
    }
    case 2: {
      type = 'danger'
      break
    }
    case 3:
    case 5: {
      type = 'warning'
      break
    }
  }
  storage.tips = {
    type,
    text
  }
}
// 初始化设置
const init = async () => {
  const { code = '' } = route.params
  if (code !== '') {
    storage.code = code
    const submitList = getStorage('submit-list', 'array')
    if (submitList.includes(code)) {
      setTips({ state: 1, text: '已提交' })
    } else {
      storage.submitList = submitList
      try {
        const res = await getFormDetail({ code })
        if (res.code === 200) {
          const { formField, ...more } = res.data
          const { status, open, people, fillPeople } = res.data
          storage.info = more
          document.title = `${more['title']}`
          if (!open) {
            setTips({ state: 2, text: '当前表单不存在' })
            return
          }
          if (people && fillPeople >= people) {
            setTips({ state: 5, text: '收集已结束' })
            return
          }
          if ([1, 3].includes(status)) {
            if (status === 1) {
              setTips({ state: 3, text: '收集时间未到' })
            } else {
              setTips({ state: 5, text: '收集已结束' })
            }
          } else {
            storage.state = 4
            storage.form = formField
          }
        } else {
          if (res.code === 21002) {
            setTips({ state: 2, text: '当前表单不存在' })
            return
          }
          setTips({ state: 2, text: '获取数据失败' })
        }
      } catch (e) {
        setTips({ state: 2, text: '获取数据错误' })
      }
    }
  }
}

init()

</script>

<style lang="scss" scoped>
.form-container {
  height: 100%;
  .header {
    text-align: center;
    margin: 24px 0;
    padding: 10px;
    .title {
      color: #333;
      font-size: 26px;
      font-weight: 500;
      line-height: 32px;
    }
    .desc {
      color: #666;
      font-size: 16px;
      line-height: 24px;
      margin-top: 6px;
      text-align: left;
      margin-top: 24px;
    }
  }
  :deep(.gusto-form) {
    .van-cell__title {
      font-size: 18px;
    }
  }
}
</style>
